import { Component, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-delete-ssp-source',
  standalone: false,
  templateUrl: './delete-ssp-source.component.html',
  styleUrl: './delete-ssp-source.component.scss'
})
export class DeleteSspSourceComponent {
  public data = inject(NZ_MODAL_DATA) as { sourceSSPDataLength: number };

  constructor(private dialogRef: NzModalRef<DeleteSspSourceComponent>) { }

  public onCloseModal(): void {
    this.dialogRef.close(false);
  }

  public onConfirm(): void {
    this.dialogRef.close(true);
  }
}
